import React, {useEffect} from 'react';
import TextareaComponent from '../Components/TextareaComponent'

/**
 * @param {[][]} props.components - 2d array  which contains for every row of a data element the inside components
 * @param {setState} props.setComponents - hook method that handle components variable 
 * @param {[][]} props.typeFields - 2d array which contains for every row of a data element the types of the inside components  
 * @param {setState} props.setTypeFields - hook method that handle typeFields variable
 * @param {number} props.formRowIndex - index of examined row of a data element
 * @param {number} props.indexComponent - index of radio component inside row with components
 * @param {boolean} props.clickedChangeElement - state that defines any inside component has been deleted and all components need to render again 
 * @param {setMethod} props.setClickedChangeElement - hook method that updates clickedChangeElement
 * @param {boolean} props.openAlert - state that open/closes data element pop up
 * @returns textarea component inside rows of data element and its options ( update placeholder, required attribute)
 */
const TextareaDataComponent = (props) => {

    const {
        components,
        setComponents,
        typeFields,
        setTypeFields,
        formRowIndex,
        indexComponent,
        clickedChangeElement,
        setClickedChangeElement,
        openAlert
    }= props

    const [placeholder, setPlaceholder] = React.useState(); // placehoder of textarea component
    const [required, setRequired] = React.useState(false); // required attribute of textarea component

    /**
     * Initializes required attribute and placeholder of textarea component and 
     * runs again when inside component has been deleted or added
     */
    useEffect( () => {
        setRequired(components[formRowIndex][indexComponent].required);
        setPlaceholder(components[formRowIndex][indexComponent].placeholder);
    },[openAlert, clickedChangeElement])

    // Update placeholder
    const changePlaceholder = (val) =>{
        const tempComponents = [...components];
        tempComponents[formRowIndex][indexComponent].placeholder = val.target.value;
        setComponents(tempComponents);

        setPlaceholder(val.target.value);
    }

    // Update required attribute
    const changeCheckbox = () => {
        const tempComponents = [...components];
        if(tempComponents[formRowIndex][indexComponent].required === true){
            setRequired(false);
            tempComponents[formRowIndex][indexComponent].required = false;
            setComponents(tempComponents);
        }
        else{
            setRequired(true);
            tempComponents[formRowIndex][indexComponent].required = true;
            setComponents(tempComponents);
        }
    }

    // Delete inside textarea component
    const deleteComponent = () => {

        const tempComponents = [...components];
        tempComponents[formRowIndex].splice(indexComponent,1);
        setComponents(tempComponents);

        const tempTypeFields = [...typeFields];
        tempTypeFields[formRowIndex].splice(indexComponent,1);
        setTypeFields(tempTypeFields);
        setClickedChangeElement(true); // set ClickedChangeElement to true in order to rerender all components of data element
    } 

    return(
        <TextareaComponent
            deleteComponent = {deleteComponent}
            placeholder = {placeholder}
            required = {required}
            changePlaceholder= {changePlaceholder}
            changeCheckbox = {changeCheckbox}
        />
    )
}

export default TextareaDataComponent;